export const domain = () => {
  const url = new URL(window.location.href);
  return `${url.protocol}//${url.hostname}${url.port && ":" + url.port}`;
};

export const DATE_FORMAT = "D MMM YYYY, hh:mm:ssA";
export const MAX_ANSWER_LENGTH = 140;
export const LOCALSTORAGE_VERSION = 0.2;
